(() => {
  window.Varellea.register('cart-drawer', root => {
    const controller = new AbortController();
    const closeButton = root.querySelector('[data-cart-drawer-close]');
    const content = root.querySelector('[data-cart-drawer-content]');
    const status = root.querySelector('[data-cart-drawer-status]');
    const errorLink = root.querySelector('[data-cart-drawer-error-link]');
    let returnFocus, sectionRequest, recommendationRequest, busy = false, previousOverflow = '';

    function open(trigger) {
      if (root.open) return;
      returnFocus = trigger || document.activeElement;
      previousOverflow = document.body.style.overflow;
      root.showModal();
      document.body.style.overflow = 'hidden';
      closeButton.focus();
    }
    function close() { if (root.open) root.close(); }
    function restoreFocus(focus) {
      if (!root.open || !focus) return;
      let target;
      if (focus.kind === 'note') target = content.querySelector('[data-cart-note-form] textarea');
      else if (focus.kind === 'quantity') target = content.querySelector(`[data-line-index="${focus.index}"] [data-cart-quantity]`) || content.querySelector('[data-cart-quantity]');
      else if (focus.kind === 'remove') target = content.querySelector(`[data-line-index="${focus.index}"] [data-cart-remove]`) || content.querySelector('[data-cart-remove]') || closeButton;
      target?.focus({ preventScroll: true });
    }
    async function loadRecommendations() {
      recommendationRequest?.abort();
      const host = content.querySelector('[data-cart-recommendations]');
      if (!host?.dataset.productId) return;
      recommendationRequest = new AbortController();
      const url = new URL(root.dataset.recommendationsUrl, location.origin);
      url.searchParams.set('section_id', 'cart-drawer');
      url.searchParams.set('product_id', host.dataset.productId);
      url.searchParams.set('intent', host.dataset.intent || 'related');
      url.searchParams.set('limit', host.dataset.limit || '3');
      try {
        const response = await fetch(url, { signal: recommendationRequest.signal, credentials: 'same-origin' });
        if (!response.ok) return;
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = parsed.querySelector('[data-cart-recommendations]');
        if (!incoming || recommendationRequest.signal.aborted) return;
        window.Varellea.unmount(host);
        host.replaceChildren(...incoming.childNodes);
        window.Varellea.mount(host);
      } catch (_) {}
    }
    async function refreshSection(focus) {
      sectionRequest?.abort();
      recommendationRequest?.abort();
      sectionRequest = new AbortController();
      errorLink.hidden = true;
      const url = new URL(root.dataset.cartUrl, location.origin);
      url.searchParams.set('section_id', 'cart-drawer');
      try {
        const response = await fetch(url, { signal: sectionRequest.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Cart refresh failed');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = parsed.querySelector('[data-cart-drawer-content]');
        if (!incoming) throw new Error('Cart content unavailable');
        window.Varellea.unmount(content);
        content.replaceChildren(...incoming.childNodes);
        window.Varellea.mount(content);
        const heading = parsed.querySelector('.v-cart-drawer__head h2');
        if (heading) root.querySelector('.v-cart-drawer__head h2').textContent = heading.textContent;
        restoreFocus(focus);
        loadRecommendations();
        return true;
      } catch (error) {
        if (error.name !== 'AbortError') { status.textContent = root.dataset.errorLabel; errorLink.hidden = false; }
        return false;
      }
    }
    async function mutate(kind, key, quantity, focus) {
      if (busy) return;
      busy = true;
      content.setAttribute('aria-busy', 'true');
      status.textContent = '';
      try {
        const cart = kind === 'note' ? await window.VarelleaCart.updateNote(quantity) : await window.VarelleaCart.change(key, quantity);
        window.VarelleaCart.publish(cart, { source: 'drawer', countLabel: root.dataset.countLabel });
        const refreshed = await refreshSection(focus);
        if (refreshed) status.textContent = kind === 'note' ? root.dataset.noteLabel : quantity === 0 ? root.dataset.removeLabel : root.dataset.updateLabel;
      } catch (error) {
        status.textContent = error.message || root.dataset.errorLabel;
        errorLink.hidden = false;
        const input = content.querySelector(`[data-cart-quantity][data-line-key="${CSS.escape(key || '')}"]`);
        if (input) input.value = input.dataset.currentQuantity;
      } finally { busy = false; content.removeAttribute('aria-busy'); }
    }
    function onClick(event) {
      const button = event.target.closest('[data-cart-increase], [data-cart-decrease], [data-cart-remove]');
      if (!button || !content.contains(button)) return;
      const line = button.closest('[data-cart-line]');
      const input = line.querySelector('[data-cart-quantity]');
      const current = Number(input.value) || Number(input.dataset.currentQuantity);
      const quantity = button.hasAttribute('data-cart-remove') ? 0 : button.hasAttribute('data-cart-increase') ? current + 1 : Math.max(0, current - 1);
      mutate('line', line.dataset.lineKey, quantity, { kind: quantity === 0 ? 'remove' : 'quantity', index: line.dataset.lineIndex });
    }
    function onChange(event) {
      const input = event.target.closest('[data-cart-quantity]');
      if (!input || !content.contains(input)) return;
      const quantity = Number(input.value);
      if (!Number.isInteger(quantity) || quantity < 1) { input.value = input.dataset.currentQuantity; return; }
      if (quantity !== Number(input.dataset.currentQuantity)) mutate('line', input.dataset.lineKey, quantity, { kind: 'quantity', index: input.closest('[data-cart-line]').dataset.lineIndex });
    }
    function onSubmit(event) {
      const form = event.target.closest('[data-cart-note-form]');
      if (!form || !content.contains(form)) return;
      event.preventDefault();
      mutate('note', null, form.querySelector('textarea[name="note"]').value, { kind: 'note' });
    }
    function onCartUpdated(event) {
      if (event.detail?.source === 'drawer') return;
      if (event.detail?.openDrawer && root.dataset.openAfterAdd === 'true') open();
      if (root.open) refreshSection();
    }
    function onHeaderClick(event) {
      const link = event.target.closest('[data-header-cart-link]');
      if (!link) return;
      event.preventDefault();
      open(link);
      refreshSection();
    }
    function onClose() {
      document.body.style.overflow = previousOverflow;
      sectionRequest?.abort(); recommendationRequest?.abort();
      (returnFocus?.isConnected ? returnFocus : document.querySelector('[data-header-cart-link]'))?.focus();
    }
    return {
      connect() {
        document.addEventListener('varellea:cart:updated', onCartUpdated, { signal: controller.signal });
        document.addEventListener('click', onHeaderClick, { signal: controller.signal });
        closeButton.addEventListener('click', close, { signal: controller.signal });
        content.addEventListener('click', onClick, { signal: controller.signal });
        content.addEventListener('change', onChange, { signal: controller.signal });
        content.addEventListener('submit', onSubmit, { signal: controller.signal });
        root.addEventListener('click', event => { if (event.target === root) close(); }, { signal: controller.signal });
        root.addEventListener('close', onClose, { signal: controller.signal });
      },
      disconnect() { controller.abort(); sectionRequest?.abort(); recommendationRequest?.abort(); window.Varellea.unmount(content); close(); }
    };
  });
})();
